import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useFlyerReorderPost = () => {
  const branchId = useBranchId();
  const { t } = useTranslation();

  const mutation = useMutation({
    mutationFn: ({ flyerId, body }: { flyerId: number; body: string }) => {
      return post2(
        `/internal/secure/pos/v1/flyer/reorder/${branchId}/${flyerId}`,
        { mail_body: body }
      );
    },
    onSuccess: () => {
      toast.success(t("success.success"));
    },
  });

  return mutation;
};

export default useFlyerReorderPost;
